<script lang="ts">
	import { page } from '$app/stores';

	let { children } = $props();

	// Map slug → article title for breadcrumb
	const articleTitles: Record<string, string> = {
		'sequence-pedagogique-vs-seance': 'Séquence Pédagogique vs Séance : Quelle Différence ?',
		'fiche-preparation': 'Fiche de préparation de séance, modèle Word et PDF à télécharger',
		'cahier-journal-enseignant': 'Cahier Journal : Comment le Tenir Sans Y Passer Vos Soirées',
		'ia-enseignement-outils-2026': 'IA pour Enseignants : 7 Outils Gratuits en 2026',
		'applications-enseignants-2026': 'Applications pour Enseignants : Top 10 en 2026',
		'progression-annuelle': 'Progression Annuelle : Comment la Construire Efficacement',
		'livret-scolaire-unique': 'Remplir le LSU : méthode, du paramétrage au verrouillage',
		'appreciations-lsu': 'Appréciations LSU : exemples par domaine, du CP au CM2',
		'differenciation-pedagogique': 'Différenciation Pédagogique : Outils et Stratégies',
		'objectifs-pedagogiques-smart': 'Objectifs Pédagogiques : Formuler des Objectifs SMART',
		'fiche-sequence-maternelle': 'Fiche de Séquence Maternelle : Exemples et Modèles',
		'gestion-temps-classe': 'Gestion du Temps en Classe : Astuces Concrètes',
		'rituels-classe': 'Rituels du matin en classe, 15 idées de la maternelle au CM2',
		'cahier-journal-en-ligne': 'Teetsh, Edumoov, prix et comparatif des cahiers journal en ligne',
		'appreciations-bulletin-primaire': 'Appréciations bulletin primaire, 40 exemples à copier ou en PDF',
		'differenciation-evaluation-primaire': 'Différenciation Évaluation Primaire : 4 Techniques',
		'evaluation-mathematiques-ce1': 'Évaluation mathématiques CE1, 3 évaluations à imprimer avec corrigé',
		'progression-annuelle-cp': 'Progression Annuelle CP : Le Guide Complet',
		// Ajoutés le 21/08/2026 : ces 15 guides tombaient dans le fallback `?? slug`,
		// donc leur BreadcrumbList affichait le slug brut (ex. "exercices-maths-ce2").
		'histoire-geographie-cp': 'Histoire-géographie au CP : enseigner le nouveau programme 2026',
		'histoire-geographie-cm1': 'Histoire-géographie au CM1, le nouveau programme 2026',
		'sciences-technologie-cp': 'Sciences et technologie au CP : enseigner le nouveau programme 2026',
		'sciences-technologie-cm1': 'Sciences et technologie au CM1, le nouveau programme 2026',
		'programme-cp-2026': 'Programme CP 2026, les objectifs de l’année matière par matière',
		'programme-ce1-2026': 'Programme CE1 2026, les objectifs de l’année matière par matière',
		'programme-ce2-2026': 'Programme CE2 2026, les objectifs de l’année matière par matière',
		'programme-cm1-2026': 'Programme CM1 2026, les objectifs de l’année matière par matière',
		'programme-cm2-2026': 'Programme CM2 2026, les objectifs de l’année matière par matière',
		'attendus-maternelle-2026': 'Attendus maternelle 2026 en PS, MS et GS, le programme par section',
		'programmes-2026-2027-ce-qui-change': "Programmes 2026-2027 : ce qui change à l'école primaire",
		'programmation-evar': 'Programmation EVAR : mettre en œuvre le programme de la PS au CM2',
		'programmation-evar-cm1-cm2': 'EVAR CM1 CM2, objectifs du programme et programmation des séances',
		'programmation-evar-maternelle': 'EVAR en maternelle, objectifs par âge pour la PS, la MS et la GS',
		'programme-emc-cp': 'Programme EMC CP 2026, contenus officiels et programmation',
		'evaluation-mathematiques-ce2': 'Évaluation mathématiques CE2, 3 évaluations à imprimer avec corrigé',
		'evaluation-mathematiques-cm1': 'Évaluation mathématiques CM1, 3 évaluations à imprimer avec corrigé',
		'plan-de-classe': 'Plan de classe, la méthode et l’outil en ligne',
		'plan-de-classe-vierge': 'Plan de classe vierge à imprimer',
		'gerer-le-bruit-en-classe': 'Gérer le bruit en classe : 8 stratégies efficaces',
		'exercices-multiplication-ce2': 'Exercices multiplication CE2 à imprimer',
		'exercices-division-cm1': 'Exercices division CM1 à imprimer',
		'exercices-division-cm2': 'Exercices division CM2 à imprimer',
		'exercices-maths-ce1': 'Exercices maths CE1 à imprimer',
		'emploi-du-temps-cp': 'Emploi du temps CP 2026-2027 : la nouvelle grille et un exemple',
		'exercices-maths-ce2': 'Exercices de maths CE2 : compétences, progression et remédiation'
	};

	let currentPath = $derived($page.url.pathname);
	let slug = $derived(currentPath.replace('/guide/', '').replace('/guide', ''));
	let isArticle = $derived(slug.length > 0 && slug !== '/');
	// Dernier recours : un slug oublié ne doit jamais sortir tel quel dans le schema.
	function deslugify(s: string): string {
		const t = s.replace(/-/g, ' ').trim();
		return t.charAt(0).toUpperCase() + t.slice(1);
	}
	let articleTitle = $derived(isArticle ? (articleTitles[slug] ?? deslugify(slug)) : '');

	let breadcrumbJson = $derived(JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{ '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://fichesequence.fr' },
			{ '@type': 'ListItem', position: 2, name: 'Guides', item: 'https://fichesequence.fr/guide' },
			...(isArticle ? [{ '@type': 'ListItem', position: 3, name: articleTitle, item: `https://fichesequence.fr${currentPath}` }] : [])
		]
	}));
</script>

<svelte:head>
	{@html `<script type="application/ld+json">${breadcrumbJson}<\/script>`}
</svelte:head>

{@render children()}
